// extracted by mini-css-extract-plugin
export default {"container":"SettingsToggle_container__Ioq3H","circle":"SettingsToggle_circle__PbKNo","active":"SettingsToggle_active__E7StS"};